import people from './people';

export default { people };
